export interface GenreCategory {
  name: string;
  items: string[];
}

export const genres: GenreCategory[] = [
  {
    name: "Танцевальный",
    items: ["Танцевать", "Праздничный", "Груви", "Среднетемповый", "Синкопированный", "Подвыпивший"]
  },
  {
    name: "Темный",
    items: ["Атмосферный", "Холодный", "Темный", "Рок", "Драматический", "Зловещий"]
  },
  {
    name: "Эклектический",
    items: ["Приложение", "Искусство", "Каприччио", "Медоточивый", "Ню", "Прогрессивный", "Необычный"]
  },
  {
    name: "Эмоция",
    items: ["Гимн", "Эмоциональный", "Счастливый", "Ликующий", "Меланхолия", "Грустный"]
  },
  {
    name: "Лирический",
    items: ["Бродвей", "Кабаре", "Комната отдыха", "Оперный", "Повествования", "Факел-лаунж", "Театральный", "Трубадур", "Вегас"]
  },
  {
    name: "Магический",
    items: ["Эфирный", "Величественный", "Таинственный"]
  },
  {
    name: "Минимальный",
    items: ["Окружающий", "Кинематографический", "Жара", "Минимальный", "Медленный", "Редкий"]
  },
  {
    name: "Мягкий",
    items: ["Окружающий", "Спальня", "Чиллвейв", "Эфирный", "Интимный", "Жара", "Садкор"]
  },
  {
    name: "Странный",
    items: ["Карнавал", "Искажённый", "Глючный", "Часто посещаемый", "Полый", "Музыкальная шкатулка", "Случайный"]
  },
  {
    name: "Мир/Этнические",
    items: ["Арабский", "Бангра", "Калипсо", "Чалга", "Египетский", "Индийский", "Хогаку", "Еврейская музыка", "Клезмер", "Мацури", "Средний Восток", "Полька", "Песня ВМФ России", "Суомипоп", "Племенной"]
  },
  {
    name: "Электронный",
    items: ["Гипногогический", "IDM", "Фонк", "Синти-поп", "Техно", "Ловушка"]
  },
  {
    name: "Джаз/Соул",
    items: ["Бибоп", "Евангелие", "Электро", "Фрутигер Аэро", "Джаз", "Латинский джаз", "РнБ", "Душа"]
  },
  {
    name: "Металл",
    items: ["Блэк-метал", "Дэткор", "Дэт-метал", "Тяжелый металл", "Металкор", "Ню Метал", "Силовой металл"]
  },
  {
    name: "Популярный",
    items: ["Поп", "Дэнс-поп", "Поп-рок", "Кпоп", "Джпоп", "РнБ", "Синти-поп"]
  },
  {
    name: "Рок",
    items: ["Классический рок", "Блюз-рок", "Эмо", "Глэм-рок", "Хардкор-панк", "Инди", "Панк", "Скала"]
  }
];